export default __webpack_public_path__ + "locales/it/Settings.json?hash=666f57a04eff3a2c15928864f350d27f";